(ns rothko.theme.manatee.editor.toolbar
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem]]))

(def common
  {:button-margin [[0 (rem 0.25)]]
   :button-display :flex
   :button-justify-content :center
   :button-align-content :center})

(def main
  {:est-transcription-annotator common
   :est-error-annotator common
   :script-annotator common
   :mwe-annotator common})
